import { useIntl } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Gift } from '@sorare/core/src/atoms/icons/Gift';
import { ANY_SPORT_MY_CARDS_BOXES_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useOneTimeDialogContext } from '@sorare/core/src/contexts/oneTimeDialog';
import { OneTimeDialog } from '@sorare/core/src/contexts/oneTimeDialog/Provider';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { TimeLeft } from '@sorare/core/src/contexts/ticker/TimeLeft';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';

import { LoyaltyBoxDialog } from './LoyaltyBoxDialog';

export const LoyaltyBoxButton = () => {
  const { currentUser } = useCurrentUserContext();

  const loyaltyBox = currentUser?.loyaltyBoxes.nodes[0];
  const time = loyaltyBox?.openableAt;

  const { generateSportContextPath } = useSportContext();
  const { formatMessage } = useIntl();

  const { sawDialog } = useOneTimeDialogContext();

  const loyaltyBoxPath = generateSportContextPath(
    ANY_SPORT_MY_CARDS_BOXES_TYPE,
    {
      sport: Sport.FOOTBALL,
      params: {
        type: 'loyalty',
      },
    }
  );

  if (!time) return null;

  return (
    <>
      <Button
        to={loyaltyBoxPath}
        size="medium"
        style={{
          backgroundColor:
            'color-mix(in srgb, var(--c-yellow-600) 10%, transparent)',
        }}
      >
        <span style={{ color: 'var(--c-yellow-600)' }}>
          <Gift />
        </span>
        <TimeLeft
          time={time}
          endLabel={formatMessage({
            id: 'loyalty-box-button.end-label',
            defaultMessage: 'Open your box',
          })}
        />
      </Button>
      <OneTimeDialog
        dialogId={LIFECYCLE.sawLoyaltyBoxDialog}
        show={!sawDialog(LIFECYCLE.sawLoyaltyBoxDialog)}
      >
        {({ onClose, open }) => (
          <LoyaltyBoxDialog
            loyaltyBox={loyaltyBox}
            onClose={onClose}
            open={open}
          />
        )}
      </OneTimeDialog>
    </>
  );
};
